import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=a4c8c54a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=a4c8c54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c8c54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4c8c54a')) {
      api.createRecord('a4c8c54a', component.options)
    } else {
      api.reload('a4c8c54a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=a4c8c54a&scoped=true&", function () {
      api.rerender('a4c8c54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8MoZ2adRwiYg9/JS/comp/DateRangeExt.vue"
export default component.exports